import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { convertNumber } from 'helpers/utils';

import { Icon } from 'components/Icon';
import { Loader } from 'components/Loader';

const RentCard = ({ user, rentId, rentTerm, instruments, comment, userOption }) => {
  const history = useHistory();

  const handleRedirect = () => {
    history.push(`/rent/${rentId}`);
  };

  const cardDate = moment(rentTerm * 1000).format('DD.MM.YY');
  const cardTime = moment(rentTerm * 1000).format('HH.mm');

  return (
    <div className="column-block" onClick={() => handleRedirect()}>
      {!userOption && <Loader type="small" color="skyblue" />}
      {userOption?.rent_fio && (
        <div className="column-property">
          <div className="column-item">{user.isCreatedInside ? <Icon name="user" /> : <Icon name="userverify" />}</div>

          <div className="column-item">-</div>

          <div className="column-value">
            <b>{user.FIO}</b>
          </div>
        </div>
      )}

      {userOption?.rent_phone_number && (
        <div className="column-property">
          <div className="column-item">
            <Icon name="phone" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value">
            <b>{convertNumber(user.PhMain)}</b>
          </div>
        </div>
      )}

      {userOption?.rent_date && (
        <div className="column-property">
          <div className="column-item">
            <Icon name="calendar" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value">
            до <b>{cardTime}</b> - {cardDate}
          </div>
        </div>
      )}

      {userOption?.rent_instruments && (
        <div className="column-property" style={{ alignItems: 'flex-start' }}>
          <div className="column-item">
            <Icon name="instrument" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value">
            {instruments &&
              instruments.map((instrument, i) => (
                <p key={i}>
                  <b data-for="instruments" data-tip={instrument.title.length <= 18 ? '' : instrument.title}>
                    {i + 1}.{' '}
                    {instrument.title.length <= 18 ? instrument.title : `${instrument.title.substring(0, 16)}...`}
                  </b>{' '}
                  - {instrument.quantity - instrument.quantityOUT} шт
                </p>
              ))}
          </div>
        </div>
      )}

      {comment && userOption?.rent_commentary && (
        <div className="column-property" style={{ alignItems: 'flex-start' }}>
          <div className="column-item">
            <Icon name="comment-small" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value" data-for="commentary" data-tip={comment.length <= 28 ? '' : comment}>
            {comment.length <= 28 ? comment : `${comment.substring(0, 25)}...`}
          </div>
        </div>
      )}
    </div>
  );
};

RentCard.propTypes = {
  user: PropTypes.object,
  rentId: PropTypes.string,
  rentTerm: PropTypes.number,
  instruments: PropTypes.array,
  comment: PropTypes.string,
  userOption: PropTypes.any,
};

RentCard.defaultProps = {
  user: {},
  rentTerm: Math.floor(Date.now() / 1000),
};

export { RentCard };
